<template>
  <div class="page-class page-user-list">
    <h1 class="page-title text-center">{{ title }}</h1>
    <checklist-box
      :columns="columns"
      :rows="permissionsList"
      :baseUrl="baseUrl"
      :loading="loading"
      :showAdd="true"
      :showDownload="false"
      :showToolbar="false"
      :showPagination="false"
      :pagination="pagination"
      addText="Create new Permission"
      emptyText="No permissions found. Please add new permissions."
      @add="onAdd"
      @edit="onEdit"
    >
      <template v-slot:emailAddressFormatted="slotProps">
        <span class="span-text span-block">
          {{ slotProps.row.email }}
        </span>
        <template v-if="slotProps.row.confirmedAtFormatted">
          <span class="text-success span-help-text" :title="slotProps.row.confirmedAt">
            ({{ slotProps.row.confirmedAtFormatted }})
          </span>
        </template>
        <template v-if="slotProps.row.confirmedAtFormatted === null">
          <span class="text-warning span-help-text"> (Not confirmed) </span>
        </template>
      </template>
      <template v-slot:lastLoginAtFormatted="slotProps">
        <template v-if="slotProps.row.lastLoginAtFormatted">
          <span class="text-success">{{ slotProps.row.lastLoginAtFormatted }}</span>
        </template>
        <template v-if="slotProps.row.lastLoginAtFormatted == null">
          <span class="text-warning">Never logged in</span>
        </template>
      </template>
      <template v-slot:blockedAtFormatted="slotProps">
        <template v-if="slotProps.row.blockedAtFormatted">
          <span class="text-success">{{ slotProps.row.blockedAtFormatted }}</span>
        </template>
        <template v-if="slotProps.row.blockedAtFormatted == null">
          <span class="text-warning">Never logged in</span>
        </template>
      </template>
    </checklist-box>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import ChecklistBox from '@/components/ChecklistBox.vue';
import router from '@/router';
// import _ from 'lodash';

export default {
  name: 'Permissions',
  components: { ChecklistBox },
  metaInfo() {
    return {
      title: 'Permissions',
      meta: [
        {
          name: 'description',
          content: `Manage permissions`
        }
      ]
    };
  },
  mounted() {
    this.listPermission({ router });
  },
  data() {
    return {
      title: 'Permissions',
      columns: [
        {
          type: 'row_num',
          headerText: '#',
          class: { ' text-center': true },
          textKey: 'index',
          width: '20%'
        },
        {
          type: 'string',
          headerText: 'Name',
          class: { 'text-center': true },
          textKey: 'name',
          width: '30%'
        },
        {
          type: 'string',
          headerText: 'Description',
          class: { 'text-center': true },
          textKey: 'description',
          width: '30%'
        },
        {
          type: 'functions',
          headerText: 'Functions',
          class: { 'text-center': true },
          width: '20%',
          functions: {
            edit: true
          }
        }
      ]
    };
  },
  computed: {
    ...mapState('permission', ['loading', 'baseUrl', 'permissionsList', 'pagination'])
  },
  methods: {
    ...mapActions('permission', ['listPermission']),
    onAdd() {
      router.push('/permissions/new');
    },
    onEdit({ row }) {
      router.push(`/permissions/${row.id}`);
    }
  }
};
</script>

<style></style>
